module.exports = __webpack_public_path__ + "img/sw1.c853dc75.svg";